export default 'https://tme.understood.org/assets/spider_mask.abc55605.jpg'